export default class Choose {
    private fulfilled = false;

    public when(condition: boolean): boolean {
        return this.elsewhen(condition, true);
    }

    public elsewhen(condition: boolean, isFirst: boolean = false): boolean {
        if (isFirst) {
            this.fulfilled = false;
        }
        if (!this.fulfilled) {
            this.fulfilled = condition;
            return this.fulfilled;
        }
        return false;
    }

    public otherwise(): boolean {
        return this.elsewhen(true);
    }
}
